


export const Colors = {primary: '#197278',primaryDark: '#283D3B', accent: '#C44536',accentDark: '#772E25', background: '#EDDDD4', fontColor: '#0E0E0E'};
export const SPACING = {MARGIN: 25,USER_IMAGE: 75};